import { CustomConditionModel, SpecialConditionData } from '@urbanx/agx.campaigns.client';
import {
  AgxButton,
  AgxCollapsible,
  AgxSpacer,
  AgxTextArea,
  Icon_TrashOutline,
} from '@urbanx/agx.ui-components2';
import { MandatorySpecialConditionDueDate } from './MandatorySpecialConditionDueDate';
import type { CustomConditionUpdater } from './customSpecialConditionEditor';

interface CustomSpecialConditionProps {
  specialConditions: SpecialConditionData[];
  customCondition: CustomConditionModel;
  onChange: (_updateCondition: CustomConditionUpdater) => void;
  onDelete: (_clauseId: string) => void;
  triggerValidation?: boolean;
  clausePosition: string;
  campaignId: string;
  hideDeleteButton?: boolean;
}

const CustomSpecialCondition = ({
  specialConditions,
  customCondition,
  onChange,
  clausePosition,
  campaignId,
  onDelete,
  triggerValidation = false,
  hideDeleteButton = false,
}: CustomSpecialConditionProps) => {
  const onChangeClauseText = (newText: string) => {
    onChange((currentCondition) => ({
      ...currentCondition,
      textInput: newText,
    }));
  };

  const onDueDateChange = (overriddenDueDate: CustomConditionModel['overriddenDueDate']) => {
    onChange((currentCondition) => ({
      ...currentCondition,
      overriddenDueDate,
    }));
  };

  const onSubClauseDelete = () => {
    if (!customCondition.clauseId) return;

    onDelete(customCondition.clauseId);
  };

  return (
    <AgxCollapsible
      variant={'withDivider'}
      content={
        <AgxSpacer fill gap="spacing-xl" padding="spacing-2xl">
          <AgxTextArea
            id={`custom-condition-clause-${customCondition.clauseId}`}
            hideOptionalText
            required
            label="Details of Special Condition"
            defaultValue={customCondition.textInput || ''}
            onInputValueChange={({ value }) => onChangeClauseText(value)}
            rows={6}
            maxLength={1100}
            stretch
            error={
              !customCondition.textInput?.trim() && triggerValidation
                ? 'Special Condition Details are required'
                : undefined
            }
          />
          <MandatorySpecialConditionDueDate
            id={`custom-condition-daysFrom-${customCondition.clauseId}`}
            dueDate={customCondition.overriddenDueDate}
            specialConditions={specialConditions}
            campaignId={campaignId}
            validate={triggerValidation}
            onChange={onDueDateChange}
          />
        </AgxSpacer>
      }
      open={true}
      enableToggle
      title={`Clause ${clausePosition}`}
      headerPadding={{
        top: 'spacing-xl',
        bottom: 'spacing-xl',
        left: 'spacing-2xl',
        right: 'spacing-2xl',
      }}
      iconPosition="left"
      actionContent={
        !hideDeleteButton ? (
          <AgxButton
            id={`custom-condition-action-${customCondition.clauseId}`}
            text={''}
            variant={'image'}
            onClick={onSubClauseDelete}
            leftIcon={<Icon_TrashOutline height={18} width={18} />}
          />
        ) : undefined
      }
      isContentFit
    />
  );
};

export default CustomSpecialCondition;
